// extracted by mini-css-extract-plugin
module.exports = {"postDiySellerPackageCardWrapper":"_1YTH2","cardBackground":"BMjAv","postDiySellerPackageCardText":"_1f7uv","subTextWrapper":"_3CPIR","textSubText":"rknLi"};